import { AuthenticationStorage } from '@axilon-apps/domains-identity/shared/core'
import { useActiveBranch, useAppSelector } from '../../hooks'
import { getAuthenticationOrganizationId } from '../core'
import type { WorkScope } from './types'

export function useWorkScope(): WorkScope {
  const branchId = useActiveBranch() ?? ''
  // Subscribe to identity changes; read the token after the identity reducer commits.
  useAppSelector((state) => state.authentication)
  const viewerId = useAppSelector((state) => state.viewAs.target?.id ?? '')
  const principalId = AuthenticationStorage.accessToken?.getPayload()?.sub ?? ''
  return {
    tenantId: getAuthenticationOrganizationId() ?? '',
    branchId,
    viewerId: `${principalId}:${viewerId}`
  }
}
